<template>

  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>
  <div class="cell small-12">
    <h1>Accounts Office Reference</h1>
    <p>An accounts office reference is a unique reference that HMRC uses to identify and allocate payments to HMRC.</p>
    <p>Your accounts office reference can be found on any correspondance from HMRC or by logging into your gov.uk gateway account.</p>
    </div>  
    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <input 
              type="text" 
              id="accountsOfficeReference" 
              name="accountsOfficeReference" 
              placeholder="" 
              v-model="formData.accountsOfficeReference" 
              required
              pattern="[A-Za-z0-9]{10}"
              maxlength="13"
              @input="formData.accountsOfficeReference = formData.accountsOfficeReference.toUpperCase()"
            />
      </form>
    </div>



</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];

  const ref = (props.formData.accountsOfficeReference || '').toUpperCase();
  if (!/^[0-9]{3}P[A-Z][0-9]{7}[0-9X]$/.test(ref)) {
    error.value.push(
      "Please enter a valid Accounts Office Reference."
    );
  }


  if (error.value.length > 0) return false;

  return true;
}



const executeStep = async () => {
  return true;
}




onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>